<div class="users">
  <mat-card>
    <mat-card-content>
      <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
        <label>Your renders</label>
        <button mat-flat-button color="accent" (click)="toggleSituConnectMode()">
          <mat-icon>{{ isSituConnectMode ? 'photo_library' : 'hub' }}</mat-icon>
          {{ isSituConnectMode ? 'Browse situVIEW' : 'Browse situCONNECT' }}
        </button>
      </div>
      <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
        <mat-card-content fxLayoutAlign="start center" fxLayout="column">
          <div class="filter w-100" fxFlex="100" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
            <mat-form-field class="accent">
              <mat-label>Search renders</mat-label>
              <input matInput type="text"
                [(ngModel)]="filter"
                (keyup.enter)="isSituConnectMode ? loadSituConnectRenders() : loadRenderedOutputs()"
                (keyup.esc)="filter=''; isSituConnectMode ? loadSituConnectRenders() : loadRenderedOutputs()"
                name="searchTerm"
                placeholder="Search Name">
              <button mat-button *ngIf="filter" matSuffix mat-icon-button aria-label="Clear" (click)="filter=''; isSituConnectMode ? loadSituConnectRenders() : loadRenderedOutputs()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
            <mat-form-field class="accent" *ngIf="!isSituConnectMode">
              <mat-label>Product Type</mat-label>
              <mat-select [(ngModel)]="product" (selectionChange)="onProductTypeChange($event.value)">
                <mat-option *ngFor="let option of productTypeOptions" [value]="option.value">
                  {{ option.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div fxLayout="row" fxLayoutGap="10px">
              <button mat-icon-button *ngIf="!isSituConnectMode"
                [matTooltip]="showAdvancedFilters ? 'Hide advanced filters' : 'Advanced filters'"
                [color]="(release || styleTemplateName || masterFile) ? 'accent' : 'basic'"
                (click)="toggleAdvancedFilters()">
                <mat-icon>tune</mat-icon>
              </button>
              <button mat-icon-button *ngIf="!isSituConnectMode" [matTooltip]="isProductionOnly ? 'Show all!' : 'Live only!'" [color]="isProductionOnly ? 'accent' : 'basic'" (click)="toggleIsProductionOnly()">
                <mat-icon>verified</mat-icon>
              </button>
              <button type="submit" mat-flat-button color="primary" (click)="isSituConnectMode ? loadSituConnectRenders() : loadRenderedOutputs()" matTooltip="Search" [class.button-spinner]="loading" [disabled]="loading">
                <mat-icon>search</mat-icon> Search
              </button>
            </div>
          </div>
          <div class="advanced-filters w-100" *ngIf="showAdvancedFilters && !isSituConnectMode" fxLayout="row wrap" fxLayoutGap="15px" fxLayoutGap.lt-sm="0" fxLayout.lt-sm="column">
            <mat-form-field class="accent" fxFlex="280px" fxFlex.lt-sm="100">
              <mat-label>Release</mat-label>
              <input type="text" matInput
                [matAutocomplete]="releaseAuto"
                [(ngModel)]="releaseSearch"
                name="releaseSearch"
                placeholder="Search releases">
              <button mat-button *ngIf="release" matSuffix mat-icon-button aria-label="Clear release" (click)="clearRelease(); $event.stopPropagation()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete #releaseAuto="matAutocomplete" [displayWith]="displayReleaseName" (optionSelected)="onReleaseSelected($event.option.value)">
                <mat-option *ngFor="let r of filteredReleases()" [value]="r">
                  <span>{{ r.name }}</span>
                  <small *ngIf="r.releaseDate" class="release-option-date">{{ r.releaseDate | date:'mediumDate' }}</small>
                </mat-option>
                <mat-option *ngIf="releases.length === 0" [disabled]="true">
                  <small><i>No releases for this company</i></small>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <ng-container *ngIf="selectedRelease">
              <mat-form-field class="accent" fxFlex="220px" fxFlex.lt-sm="100">
                <mat-label>Home</mat-label>
                <input type="text" matInput
                  [matAutocomplete]="homeAuto"
                  [(ngModel)]="homeSearch"
                  name="homeSearch"
                  placeholder="Filter by home"
                  [disabled]="releaseHomes().length === 0">
                <button mat-button *ngIf="homeName" matSuffix mat-icon-button aria-label="Clear home" (click)="clearFilter(HomeNameParamName); $event.stopPropagation()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete #homeAuto="matAutocomplete" (optionSelected)="onReleaseHomeSelected($event.option.value)">
                  <mat-option *ngFor="let h of filteredReleaseHomes()" [value]="h">
                    {{ h }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <mat-form-field class="accent" fxFlex="220px" fxFlex.lt-sm="100">
                <mat-label>Style template</mat-label>
                <input type="text" matInput
                  [matAutocomplete]="styleAuto"
                  [(ngModel)]="styleTemplateSearch"
                  name="styleTemplateSearch"
                  placeholder="Filter by style template"
                  [disabled]="releaseStyleTemplates().length === 0">
                <button mat-button *ngIf="styleTemplateName" matSuffix mat-icon-button aria-label="Clear style template" (click)="clearFilter(StyleNameParamName); $event.stopPropagation()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete #styleAuto="matAutocomplete" (optionSelected)="onStyleTemplateSelected($event.option.value)">
                  <mat-option *ngFor="let s of filteredReleaseStyleTemplates()" [value]="s">
                    {{ s }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <mat-form-field class="accent" fxFlex="220px" fxFlex.lt-sm="100">
                <mat-label>Master file</mat-label>
                <input type="text" matInput
                  [matAutocomplete]="masterFileAuto"
                  [(ngModel)]="masterFileSearch"
                  name="masterFileSearch"
                  placeholder="Filter by master file"
                  [disabled]="releaseMasterFiles().length === 0">
                <button mat-button *ngIf="masterFile" matSuffix mat-icon-button aria-label="Clear master file" (click)="clearFilter(MasterFileParamName); $event.stopPropagation()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete #masterFileAuto="matAutocomplete" (optionSelected)="onMasterFileSelected($event.option.value)">
                  <mat-option *ngFor="let m of filteredReleaseMasterFiles()" [value]="m">
                    {{ m }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </ng-container>
          </div>
          <div class="m-b-20 w-100" fxFlex="100">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
              <small class="text-info"><i>filter:</i></small>
              <mat-chip-list #optionChipList>
                <mat-chip *ngIf="product !== undefined" color="accent">
                  <span>{{ getProductLabel(product) }}</span>
                  <button matChipRemove (click)="onProductTypeChange(undefined)">
                    <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
                  </button>
                </mat-chip>
                <mat-chip *ngIf="release" color="accent">
                  <span>Release: {{ selectedReleaseName() || 'loading…' }}</span>
                  <button matChipRemove (click)="clearRelease()">
                    <mat-icon color="primary" matTooltip="Clear release">clear</mat-icon>
                  </button>
                </mat-chip>
                <mat-chip *ngIf="homeName" color="accent">
                  <span>Home: {{ homeName }}</span>
                  <button matChipRemove (click)="clearFilter(HomeNameParamName)">
                    <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
                  </button>
                </mat-chip>
                <mat-chip *ngIf="home" color="accent">
                  <span>Home (id)</span>
                  <button matChipRemove (click)="clearFilter(HomeParamName)">
                    <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
                  </button>
                </mat-chip>
                <mat-chip *ngIf="styleTemplateName" color="accent">
                  <span>Style: {{ styleTemplateName }}</span>
                  <button matChipRemove (click)="clearFilter(StyleNameParamName)">
                    <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
                  </button>
                </mat-chip>
                <mat-chip *ngIf="masterFile" color="accent">
                  <span>Master file: {{ masterFile }}</span>
                  <button matChipRemove (click)="clearFilter(MasterFileParamName)">
                    <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
                  </button>
                </mat-chip>
                <mat-chip *ngIf="style" color="accent">
                  <span>Style</span>
                  <button matChipRemove (click)="clearFilter(StyleParamName)">
                    <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
                  </button>
                </mat-chip>
                <mat-chip *ngIf="config" color="accent">
                  <span>Config</span>
                  <button matChipRemove (click)="clearFilter(ConfigParamName)">
                    <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
                  </button>
                </mat-chip>
                <mat-chip *ngIf="filter" color="accent">
                  <span>Search {{ filter }}</span>
                  <button matChipRemove (click)="clearFilter(FilterParamName)">
                    <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
                  </button>
                </mat-chip>
              </mat-chip-list>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Rendered Outputs View -->
      <div fxLayout="row wrap" *ngIf="!isSituConnectMode">
        <div class="md-card-wrapper" *ngFor="let item of dataSource.data">
          <mat-card class="contrast browse-card">
            <ng-container [ngSwitch]="item?.productName">
              <img *ngSwitchCase="productNames.Facade" class="card-link" style="height: 225px" (click)="onRenderSelected(item)" mat-card-image src="/assets/images/background/user-info-generic.jpg" [lazyLoad]="getFacadeImage(item?.artifactId)" matTooltip="situFACADE">
              <img *ngSwitchCase="productNames.Panorama" class="card-link" (click)="onRenderSelected(item)" mat-card-image src="/assets/images/background/user-info-generic.jpg" [lazyLoad]="getPanoImage(item?.artifactId)" matTooltip="situVIEW">
              <img *ngSwitchCase="productNames.RayTracedDraft" class="card-link" (click)="onRenderSelected(item)" mat-card-image src="/assets/images/background/user-info-generic.jpg" [lazyLoad]="getPanoImage(item?.artifactId)" matTooltip="situVIEW Draft">
              <img *ngSwitchCase="productNames.RayTraced" class="card-link" (click)="onRenderSelected(item)" mat-card-image src="/assets/images/background/user-info-generic.jpg" [lazyLoad]="getPanoImage(item?.artifactId)" matTooltip="situVIEW">
              <img *ngSwitchCase="productNames.RayTracedPlus" class="card-link" (click)="onRenderSelected(item)" mat-card-image src="/assets/images/background/user-info-generic.jpg" [lazyLoad]="getPanoImage(item?.artifactId)" matTooltip="situVIEW">
              <img *ngSwitchCase="productNames.Render" class="card-link" (click)="onRenderSelected(item)" mat-card-image src="/assets/images/background/user-info-generic.jpg" [lazyLoad]="getPanoImage(item?.artifactId)" matTooltip="situRENDER">
              <img *ngSwitchDefault class="blurred-image card-link" (click)="onRenderSelected(item)" mat-card-image src="/assets/images/background/user-info-generic.jpg">
            </ng-container>
            <mat-card-content class="browse-card-content" fxLayoutAlign="start center" fxLayout="row" fxLayout.lt-sm="column">
              <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row" fxLayout.lt-sm="column">
                <div class="w-100" fxLayout="row" fxFlex="100">
                  <div fxLayout="column" fxLayoutGap="2px" fxFlex="80">
                    <ng-container *ngIf="item?.homeConfig?.options && item?.homeConfig?.options.length > 0">
                      <div fxLayoutAlign="start start" fxLayout="row" fxLayoutGap="5px">
                        <div class="font-14">options</div>
                        <div>></div>
                      </div>
                      <small class="no-spill" [innerHtml]="item?.homeConfig?.options.join(', ') | encodeHtml | highlight: filter"></small>
                    </ng-container>
                    <ng-container *ngIf="item?.styleConfigTemplate?.name">
                      <div fxLayoutAlign="start start" fxLayout="row" fxLayoutGap="5px">
                        <div class="font-14">style</div>
                        <div>></div>
                      </div>
                      <small class="no-spill" [innerHtml]="item.styleConfigTemplate.name | encodeHtml | highlight: filter"></small>
                    </ng-container>
                  </div>
                  <div fxFlex="20">
                    <ng-container [ngSwitch]="item?.productName">
                      <span *ngSwitchCase="productNames.Facade" fxLayout="column" fxLayoutAlign="end end">
                        <mat-icon color="accent" matTooltip="2048x1536" *ngIf="item?.callerReferenceKey?.endsWith('default')">2k</mat-icon>
                        <mat-icon color="accent" matTooltip="4096x3072" *ngIf="item?.callerReferenceKey?.endsWith('4096x3072')">4k</mat-icon>
                        <mat-icon color="accent" matTooltip="8192x6144" *ngIf="item?.callerReferenceKey?.endsWith('8192x6144')">8k</mat-icon>
                        <mat-icon color="accent" matTooltip="16384x12288" *ngIf="item?.callerReferenceKey?.endsWith('16384x12288')">8k_plus</mat-icon>
                        <mat-icon [style.color]="getProductColour(item?.productName)" matTooltip="situFACADE">image</mat-icon>
                      </span>
                      <span *ngSwitchCase="productNames.Panorama" fxLayout="column" fxLayoutAlign="end end">
                        <mat-icon color="accent" matTooltip="Geometry Check">architecture</mat-icon>
                        <mat-icon [style.color]="getProductColour(item?.productName)" matTooltip="situVIEW">panorama</mat-icon>
                      </span>
                      <span *ngSwitchCase="productNames.RayTracedDraft" fxLayout="column" fxLayoutAlign="end end">
                        <mat-icon color="accent" matTooltip="ray traced draft">2k_plus</mat-icon>
                        <mat-icon [style.color]="getProductColour(item?.productName)" matTooltip="situVIEW Draft">panorama</mat-icon>
                      </span>
                      <span *ngSwitchCase="productNames.RayTraced" fxLayout="column" fxLayoutAlign="end end">
                        <mat-icon color="accent" matTooltip="ray traced">4k_plus</mat-icon>
                        <mat-icon [style.color]="getProductColour(item?.productName)" matTooltip="situVIEW">panorama</mat-icon>
                      </span>
                      <span *ngSwitchCase="productNames.RayTracedPlus" fxLayout="column" fxLayoutAlign="end end">
                        <mat-icon color="accent" matTooltip="ray traced plus">8k</mat-icon>
                        <mat-icon [style.color]="getProductColour(item?.productName)" matTooltip="situVIEW">panorama</mat-icon>
                      </span>
                      <span *ngSwitchCase="productNames.Plan" fxLayout="column" fxLayoutAlign="end end">
                        <mat-icon [style.color]="getProductColour(item?.productName)" matTooltip="situPLAN">foundation</mat-icon>
                      </span>
                      <span *ngSwitchCase="productNames.Render" fxLayout="column" fxLayoutAlign="end end">
                        <mat-icon [style.color]="getProductColour(item?.productName)" matTooltip="situRENDER">photo_camera</mat-icon>
                      </span>
                      <span *ngSwitchDefault fxLayout="column" fxLayoutAlign="end end">
                        <mat-icon color="accent" matTooltip="standard">4k</mat-icon>
                        <mat-icon [style.color]="getProductColour(item?.productName)" matTooltip="situVIEW">panorama</mat-icon>
                      </span>
                    </ng-container>
                    
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
          <span class="header" fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
              <strong [class.home-text]="isDarkMode" [innerHtml]="item?.homeConfig?.home | encodeHtml | highlight: filter"></strong>
              <mat-icon *ngIf="item?.isProduction" matTooltip="Is Live!" color="accent">verified</mat-icon>
            </div>
            <div fxLayout="row" fxLayoutAlign="end center">
              <span fxLayout="row" fxLayoutAlign="end center">
                <small [innerHtml]="item?.homeConfig?.masterFile | encodeHtml | highlight: filter"></small>
                <mat-icon *ngIf="isSituUser && allowRenderCancelation" class="text-danger link" (click)="cancelRenderedOutput(item); $event.stopPropagation();">clear</mat-icon>
              </span>
            </div>
          </span>
          <span class="footer" [class.facade]="item?.productName === productNames.Facade" fxLayout="row" fxLayoutAlign="space-between center">
            <small style="color: black; font-weight: bold;">{{ item.dateCreated | date:'short' }}</small>
            <div>
              <mat-icon *ngIf="!item?.isProduction && isSituUser" class="link" color="primary" matTooltip="Set to Live" (click)="setAsProduction(item, $event)">verified</mat-icon>
              <mat-icon *ngIf="isSituUser && canScanForProductUsage(item) && scanningArtifactId !== item.artifactId" class="link" color="accent" matTooltip="Scan for product usage" (click)="scanForProductUsage(item, $event)">fingerprint</mat-icon>
              <mat-spinner *ngIf="scanningArtifactId === item.artifactId" diameter="18" class="card-icon"></mat-spinner>
              <mat-icon *ngIf="allowOpenSituViewOrFacade" class="link" color="accent" matTooltip="Open in new Window" (click)="onRenderSelected(item, true); $event.stopPropagation();">open_in_new</mat-icon>
              <source-artifacts-menu class="card-icon"
                [isSituUser]="isSituUser"
                [isAdmin]="isAdmin"
                [isDarkMode]="isDarkMode"
                [sourceArtifacts]="item?.sourceArtifacts">
              </source-artifacts-menu>
            </div>
          </span>
        </div>
      </div>

      <!-- SituConnect View -->
      <div fxLayout="row wrap" *ngIf="isSituConnectMode">
        <div class="md-card-wrapper" *ngFor="let item of situConnectDataSource">
          <mat-card class="contrast browse-card">
            <ng-container *ngIf="getConnectType(item?.connectType) as connectType">
              <img class="card-link"
                (click)="onSituConnectSelected(item)"
                mat-card-image
                src="/assets/images/background/user-info-generic.jpg"
                [lazyLoad]="getSituConnectImage(item?.artifactId, connectType)"
                [matTooltip]="getConnectTypeTooltip(connectType)">
            </ng-container>
            <mat-card-content class="browse-card-content" fxLayoutAlign="start center" fxLayout="row" fxLayout.lt-sm="column">
              <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row" fxLayout.lt-sm="column">
                <div class="w-100" fxLayout="row" fxFlex="100">
                  <div fxLayout="column" fxLayoutGap="2px" fxFlex="80">
                    <ng-container *ngIf="item?.customerName">
                      <div fxLayoutAlign="start start" fxLayout="row" fxLayoutGap="5px">
                        <div class="font-14">customer</div>
                        <div>></div>
                      </div>
                      <small class="no-spill" [innerHtml]="item.customerName | encodeHtml | highlight: filter"></small>
                    </ng-container>
                    <ng-container *ngIf="item?.customerReference">
                      <div fxLayoutAlign="start start" fxLayout="row" fxLayoutGap="5px">
                        <div class="font-14">reference</div>
                        <div>></div>
                      </div>
                      <small class="no-spill" [innerHtml]="item.customerReference | encodeHtml | highlight: filter"></small>
                    </ng-container>
                  </div>
                  <div fxFlex="20">
                    <ng-container *ngIf="getConnectType(item?.connectType) as connectType">
                      <span fxLayout="column" fxLayoutAlign="end end">
                        <mat-icon [style.color]="getConnectIconColor(connectType)" [matTooltip]="getConnectTypeTooltip(connectType)">
                          {{ getConnectIconType(connectType) }}
                        </mat-icon>
                      </span>
                    </ng-container>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
          <span class="header" fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
              <strong [class.home-text]="isDarkMode" [innerHtml]="item?.customerName | encodeHtml | highlight: filter"></strong>
            </div>
            <div fxLayout="row" fxLayoutAlign="end center">
              <span fxLayout="row" fxLayoutAlign="end center">
                <small [innerHtml]="item?.customerReference | encodeHtml | highlight: filter"></small>
              </span>
            </div>
          </span>
          <span class="footer" fxLayout="row" fxLayoutAlign="space-between center">
            <small style="color: black; font-weight: bold;">{{ (item.dateCompleted || item.dateAdded) | date:'short' }}</small>
            <div>
              <mat-icon *ngIf="allowOpenSituViewOrFacade" class="link" color="accent" matTooltip="Open in new Window" (click)="onSituConnectSelected(item, true); $event.stopPropagation();">open_in_new</mat-icon>
            </div>
          </span>
        </div>
      </div>

      <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
        <mat-paginator [length]="viewControls.totalItems"
          [pageSize]="viewControls.pageSize"
          [pageIndex]="viewControls.pageIndex"
          [pageSizeOptions]="viewControls.pageSizeOptions"
          (page)="onPageChange($event)">
        </mat-paginator>
      </mat-card>
    </mat-card-content>
  </mat-card>
</div>